import { render, staticRenderFns } from "./TextEditorXS.vue?vue&type=template&id=a1f9338c"
import script from "./TextEditorXS.vue?vue&type=script&lang=js"
export * from "./TextEditorXS.vue?vue&type=script&lang=js"
import style0 from "./TextEditorXS.vue?vue&type=style&index=0&id=a1f9338c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports